import {
  AuthApi,
  CampaignApi,
  Configuration,
  CustomerApi,
  ProductApi,
  PurchaseOrderApi,
  ShoppingCartApi} from '@baia-api/baia-api';
import { handleResponseError } from '@components/error-boundary/error-handling.ts';
import { AxiosError } from 'axios';

const defaultBasePath = import.meta.env.DEV
  ? 'http://localhost:3000/api'
  : import.meta.env.VITE_SERVICE_BASE_URL;

function applyAxiosInterceptors(clients: Record<string, any>) {
  // Axios instance is shared -> only register interceptors once
  const client = Object.values(clients)[0];
  const ax = client?.axios ?? client?.axiosInstance;
  if (!ax || !ax.interceptors) return;

  ax.defaults.withCredentials = true;

  // Response‑Interceptor
  ax.interceptors.response.use(
    (resp: Response) => resp,
    async (err: AxiosError) => {
      await handleResponseError(err, 'API Client');
      return Promise.reject(err);
    },
  );
}

const config = new Configuration({
  basePath: defaultBasePath,
});

export const apiClient = {
  products: new ProductApi(config),
  orders: new PurchaseOrderApi(config),
  cart: new ShoppingCartApi(config),
  customer: new CustomerApi(config),
  auth: new AuthApi(config),
  campaigns: new CampaignApi(config),
};
function createConfig(opts?: { basePath?: string }) {
  return new Configuration({
    basePath: opts?.basePath ?? defaultBasePath,
  });
}

// After login provide the API with correct config inluding the auth token
export function reinitializeBaiaApiClient(opts?: { basePath?: string }) {
  let currentConfig = createConfig(opts);

  // API-Instanzen austauschen
  apiClient.products = new ProductApi(currentConfig);
  apiClient.orders = new PurchaseOrderApi(currentConfig);
  apiClient.cart = new ShoppingCartApi(currentConfig);
  apiClient.customer = new CustomerApi(currentConfig);
  apiClient.auth = new AuthApi(currentConfig);
  apiClient.campaigns = new CampaignApi(currentConfig);
}

applyAxiosInterceptors(apiClient);
